

export const defaultTheme = Object.freeze({
	formItemLabelSize: '10px',
	formItemLabelInside: false,

	inputBackground: '#ffffff',
	inputBorderRadius: '8px'
});

